import { light } from './light';

export const dark = light;
